import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import TabList from "../../ui/TabList";
import { HanMucApi } from "../restapi/hanMucApi";
import worker from "../setupWorker";
import store from "../store";
import HanMucToanBoItem from "./hanMucToanBoItem";
import "./hanMucToanBo.scss";
import Switcher from "../../ui/Switcher";
import MessageEditor from "../message/messageEditor";
import { isCuPhapMb } from "../utils/common";
import Parser from "../restapi/parser";


type OwnProps = {

}

const HanMucToanBo: FC<OwnProps> = ({

}) => {
    const tabs = [{ type: 'MB', title: 'Miền Bắc' },
    { type: 'MT', title: 'Miền Trung' },
    { type: 'MN', title: 'Miền Nam' },
    { type: 'MN', title: 'Nhập tay' },
    ]
    const [state, setState] = useState({
        activeTab: 0,
        hanMuc: {
            active: { useHanMuc: 0 },
            json: "", dmLoaiCuoc: []
        } as any,
        changeData: {} as any, // các số liệu thay đổi được đưa vào map này để post lên sv
        htmlError: "",
        errorTextToUser: "",
        rawText: "",

    })
    useEffect(() => {
        const payload = { ngay: store.getState().global.workDate }
        HanMucApi.getHanMucToanBo(payload).then(res => {
            if (res.errorCode == 0) {
                setState(prev => ({
                    ...prev, hanMuc: res.data,
                    htmlError: res.data.active.hanMucText,
                    rawText: res.data.active.hanMucText,
                }))
            } else {
                worker.postMessage({ type: 'showsnackbar', data: res.responseText })
            }
        })
    }, [])
    function handleOnSwitchTab(tabIndex: number) {
        setState(prev => ({ ...prev, activeTab: tabIndex }))
    }
    function handleOnDataChange(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(`${e.target.id} =  ${e.target.value}`)
        let value = Number(e.target.value);
        if (isNaN(value))
            value = 9999999;
        const arr = e.target.id.split(":")
        if (arr.length != 3) {
            console.error('Lỗi id')
            return
        }
        const mien = arr[0]
        const key = `${arr[1]}:${arr[2]}`
        switch (mien) {
            case "MB":
                const tmp = { ...state.hanMuc.hanMucMB }
                const item = tmp[key]
                item.nhanMax = value
                // 
                const curMap = { ...state.changeData }
                curMap[key] = item
                setState(prev => ({
                    ...prev, hanMuc: { ...prev.hanMuc, hanMucMB: tmp },
                    changeData: curMap
                }))

                break;
            case "MT":
                const tmpMt = { ...state.hanMuc.hanMucMT }
                const itemMt = tmpMt[key]
                itemMt.nhanMax = value
                // 
                const curMapMt = { ...state.changeData }
                curMapMt[key] = itemMt
                setState(prev => ({
                    ...prev, hanMuc: { ...prev.hanMuc, hanMucMT: tmpMt },
                    changeData: curMapMt
                }))
                break;
            case "MN":
                const tmpMn = { ...state.hanMuc.hanMucMN }
                const itemMn = tmpMn[key]
                itemMn.nhanMax = value
                //
                const curMapMn = { ...state.changeData }
                curMapMn[key] = itemMn
                setState(prev => ({
                    ...prev, hanMuc: { ...prev.hanMuc, hanMucMN: tmpMn },
                    changeData: curMapMn
                }))
                break;
        }
    }
    function rendertabMienBac() {
        if (Object.keys(state.hanMuc).length == 0) {
            return <div></div>
        }
        const ret: any[] = [];
        for (let loaiCuoc of state.hanMuc.dmLoaiCuoc) {
            ret.push(<HanMucToanBoItem mien="MB" loaiCuocId={loaiCuoc} hanMuc={state.hanMuc} key={loaiCuoc + "-item"}
                onDataChange={handleOnDataChange}
            />)
        }
        return ret
    }
    function rendertabMienTrung() {
        if (Object.keys(state.hanMuc).length == 0) {
            return <div></div>
        }
        const ret: any[] = [];
        for (let loaiCuoc of state.hanMuc.dmLoaiCuoc) {
            ret.push(<HanMucToanBoItem mien="MT" loaiCuocId={loaiCuoc} hanMuc={state.hanMuc} key={loaiCuoc + "-item"}
                onDataChange={handleOnDataChange} />)
        }
        return ret
    }
    function rendertabMienNam() {
        if (Object.keys(state.hanMuc).length == 0) {
            return <div></div>
        }
        const ret: any[] = [];
        for (let loaiCuoc of state.hanMuc.dmLoaiCuoc) {
            ret.push(<HanMucToanBoItem mien="MN" loaiCuocId={loaiCuoc} hanMuc={state.hanMuc} key={loaiCuoc + "-item"}
                onDataChange={handleOnDataChange} />)
        }
        return ret
    }
    function handleSaveHanMuc() {
        const keys = Object.keys(state.changeData)
        if (keys.length == 0) {
            worker.postMessage({ type: 'showsnackbar', data: 'Dữ liệu không thay đổi' })
            return
        }
        const data: any[] = []
        for (let key of keys) {
            const item = state.changeData[key]
            data.push(item)
        }
        const payload = { hanMuc: [...data] }
        HanMucApi.saveHanMucToanBo(payload).then(res => {
            worker.postMessage({ type: 'showsnackbar', data: res.responseText })
        })
    }
    //  text  nhập tay
    function handleTextChange(html: string, rawText: string) {
        setState(prev => ({ ...prev, rawText: rawText }))
    }
    async function handleParseMessage() {
        //const currentContact: any = store.getState()?.contact?.currentContact
        //const contactId = currentContact.contactId
        const payload = {
            body: state.rawText,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: 0,
            mien: "NAM",
            curMien: "NAM",
            getCompactData: 1,
            getRawData: 0,
            mienCuPhapId: isCuPhapMb() ? 1 : 2,
            tachXienMay: 3,
            soBoSo: 10,
            lockArea: 0,
        }
        if (isCuPhapMb()) {
            payload.mien = "BAC"
            payload.curMien = "BAC"
        }
        let result = await Parser.parseCanChuyenMessage(payload)
        let html = result.data.html
        if (html == "")
            html = result.data.bodyViet
        setState(prev => ({ ...prev, htmlError: html, errorTextToUser: result.responseText }))
        if (result.data.parseStatus == "parseOK") {
            const payload = { json: JSON.stringify(result.data.compactData), hanMucText: state.rawText }
            HanMucApi.saveHanMucToanBoJson(payload).then(res => {
                worker.postMessage({ type: 'showsnackbar', data: res.responseText })
            })
        } else {

        }
    }
    return (
        <div className=" form-content">
            <div className="hm-header">
                <div className=" form-header">
                    <div className=" form-header left-panel">

                        <div className=" common-container-row center">
                            <div>Hạn mức toàn bộ hệ thống</div>
                        </div>
                        <Switcher label="Tắt" checked={state.hanMuc.active.useHanMuc == 1}
                            onChange={(e) => {
                                const active = e.target.checked ? 1 : 0
                                const payload = { active: active }
                                HanMucApi.activeHanMucToanBo(payload)
                            }} />

                    </div>
                    <div className=" form-header right-panel">
                        <Button round size='tiny'
                            onClick={handleSaveHanMuc}><i className="fa-regular fa-floppy-disk"></i></Button>
                    </div>

                </div>
                <div style="position:sticky; top:0; z-index:100; background-color:white;">
                    <TabList tabs={tabs} activeTab={state.activeTab} onSwitchTab={handleOnSwitchTab} />
                </div>
            </div>

            <div className="">
                {
                    state.activeTab == 0 && rendertabMienBac()
                }
                {
                    state.activeTab == 1 && rendertabMienTrung()
                }
                {
                    state.activeTab == 2 && rendertabMienNam()
                }
                {state.activeTab == 3 &&
                    <div>
                        <MessageEditor msgType={1}
                            onTextChange={handleTextChange}
                            maxHeight="5rem"
                            hidenFontSizeSetting={false}
                            htmlError={state.htmlError}
                            errorTextToUser={state.errorTextToUser}
                            showSaveButton
                            onParseMessage={handleParseMessage}
                        ></MessageEditor>
                    </div>}
            </div>
        </div>
    )
}

export default memo(HanMucToanBo)